import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "grid gap-4 xl:grid-cols-2" }
const _hoisted_3 = { class: "mt-4 grid gap-4 md:grid-cols-3" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "mt-4 grid gap-4 md:grid-cols-3" }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiPageHero = _resolveComponent("UiPageHero")!
  const _component_UiSelect = _resolveComponent("UiSelect")!
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_UiPageHero, {
      eyebrow: "Báo cáo",
      title: "Xuất báo cáo tài sản",
      description: "Tạo báo cáo theo giá trị hoặc báo cáo tổng hợp theo năm và khoa/phòng."
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "panel-pad",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.createValueReport && $setup.createValueReport(...args)), ["prevent"]))
      }, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex flex-col gap-1 text-left" }, [
          _createElementVNode("p", { class: "text-lg font-bold text-ink" }, "Xuất báo cáo theo giá trị")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UiSelect, {
            modelValue: $setup.valueKind,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.valueKind) = $event)),
            modelModifiers: { number: true },
            label: "Chọn loại thống kê"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createElementVNode("option", { value: 1 }, "Báo cáo lớn hơn", -1),
              _createElementVNode("option", { value: 2 }, "Báo cáo nhỏ hơn", -1)
            ]))]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_UiSelect, {
            modelValue: $setup.valueLoai,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.valueLoai) = $event)),
            modelModifiers: { number: true },
            label: "Chọn loại"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dsLoai, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.value,
                  value: item.value
                }, _toDisplayString(item.label), 9, _hoisted_4))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_UiInput, {
            "model-value": $setup.valuePriceInput,
            label: "Nhập giá trị:",
            inputmode: "numeric",
            onKeydown: $setup.blockNonNumericKey,
            onPaste: _cache[2] || (_cache[2] = ($event: any) => ($setup.pasteNumericOnly($event, $setup.updateValuePrice))),
            "onUpdate:modelValue": $setup.updateValuePrice
          }, null, 8, ["model-value", "onKeydown", "onUpdate:modelValue"])
        ]),
        _createVNode(_component_UiButton, {
          type: "submit",
          class: "mt-4",
          icon: "export",
          loading: $setup.loadingValue,
          "loading-text": "Đang tạo..."
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode(" Tạo báo cáo ", -1)
          ]))]),
          _: 1
        }, 8, ["loading"])
      ], 32),
      _createElementVNode("form", {
        class: "panel-pad",
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.createSummaryReport && $setup.createSummaryReport(...args)), ["prevent"]))
      }, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex flex-col gap-1 text-left" }, [
          _createElementVNode("p", { class: "text-lg font-bold text-ink" }, "Xuất báo cáo tổng hợp")
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_UiInput, {
            modelValue: $setup.year,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.year) = $event)),
            modelModifiers: { number: true },
            label: "Nhập năm thống kê:",
            type: "number",
            min: "0"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_UiSelect, {
            modelValue: $setup.departmentId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.departmentId) = $event)),
            modelModifiers: { number: true },
            label: "Chọn khoa phòng thống kê"
          }, {
            default: _withCtx(() => [
              _cache[11] || (_cache[11] = _createElementVNode("option", { value: 0 }, "Toàn viện", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.departments, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.id,
                  value: item.id
                }, _toDisplayString(item.tenKhoaPhong), 9, _hoisted_6))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_UiSelect, {
            modelValue: $setup.summaryLoai,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.summaryLoai) = $event)),
            modelModifiers: { number: true },
            label: "Chọn loại"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dsLoai, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.value,
                  value: item.value
                }, _toDisplayString(item.label), 9, _hoisted_7))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_component_UiButton, {
          type: "submit",
          class: "mt-4",
          icon: "export",
          loading: $setup.loadingSummary,
          "loading-text": "Đang tạo..."
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode(" Tạo báo cáo ", -1)
          ]))]),
          _: 1
        }, 8, ["loading"])
      ], 32)
    ])
  ]))
}